<template>
  <v-container>
    <v-flex class="mt-2 mb-2" v-if="loading">
      <v-progress-linear indeterminate color="green"></v-progress-linear>
    </v-flex>
    <v-flex v-else>
      <v-flex
        v-if="
          value.mime_type &&
            (value.mime_type.startsWith('image/png') ||
              value.mime_type.startsWith('image/jpeg'))
        "
      >
        <p>
          <small>{{ $t("Image") }}:</small>
        </p>
        <div v-if="value.thumb">
          <a :href="value.thumb | addToken" target="_blank">
            <img :src="value.thumb | addToken" />
          </a>
        </div>
        <img
          v-else-if="value.preview.encoded"
          :src="value.preview.encoded"
          width="200px"
        />
      </v-flex>
      <v-flex v-else>
        <v-flex v-if="value.url">
          <p>
            <small>{{ $t("File") }}:</small>
          </p>
          <v-icon v-if="value.mime_type == 'application/pdf'"
            >mdi-file-pdf</v-icon
          >
          <v-icon v-else>mdi-file</v-icon>
          <a :href="value.url | addToken" target="_blank">{{ value.name }}</a>
        </v-flex>
        <v-flex v-else-if="value.name">
          <p>
            <small>{{ $t("Uploaded") }} {{ $t("File") }}:</small>
          </p>
          <v-icon v-if="value.mime_type == 'application/pdf'"
            >mdi-file-pdf</v-icon
          >
          <v-icon v-else>mdi-file</v-icon>
          {{ value.name }}
        </v-flex>
      </v-flex>
    </v-flex>
    <v-flex class="mt-6">
      <v-file-input
        show-size
        counter
        :label="$t('File input')"
        v-on:change="onChangeFileUpload()"
        v-model="chosenFile"
        v-validate=""
        data-vv-name="file"
        :error-messages="errors.collect('file')"
      ></v-file-input>
    </v-flex>
  </v-container>
</template>

<script>
export default {
  name: "FileUploader",
  $_veeValidate: {
    validator: "new"
  },
  data: function() {
    return {
      chosenFile: null,
      loading: false
    };
  },
  props: {
    value: null
  },
  methods: {
    onChangeFileUpload() {
      if (this.chosenFile) {
        let formData = new FormData();
        this.loading = true;
        formData.append("file", this.chosenFile);
        this.axios
          .post("/api/document/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(data => {
            this.loading = false;
            this.chosenFile = null;
            this.$emit("input", data.data);
            this.$emit("new-data");
          })
          .catch(error => {
            this.loading = false;
            for (let field in error.response.data.errors) {
              this.$validator.errors.add({
                field: field,
                msg: error.response.data.errors[field][0]
              });
            }
            throw error;
          });
      }
    }
  }
};
</script>
